import React, { useState } from 'react';
import Chat from './components/Chat';
import CommunityPage from './components/CommunityPage';
import { AppProvider, Page, Card, TextContainer, Button } from '@shopify/polaris';
import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react';
import '@shopify/polaris/build/esm/styles.css';
import SubscriptionModal from './components/SubscriptionModal';

function getShopDomain() {
  const params = new URLSearchParams(window.location.search);
  return params.get('shop');
}
const SHOP_DOMAIN = getShopDomain() || null;
const INSTALL_ID = SHOP_DOMAIN;
const API_BASE = process.env.REACT_APP_API_BASE || '';

function App() {
  const [page, setPage] = useState('home');
  const [currentPlan, setCurrentPlan] = useState(null);
  const isPaid = currentPlan === '20' || currentPlan === '100';
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [subscriptionError, setSubscriptionError] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Fetch current plan on mount
  React.useEffect(() => {
    async function fetchCurrentPlan() {
      if (!SHOP_DOMAIN) return;
      try {
        const res = await fetch(`/api/client/${INSTALL_ID}`);
        const data = await res.json();
        setCurrentPlan(data.subscription_plan || data.current_plan || null);
      } catch (e) {
        setCurrentPlan(null);
      }
    }
    fetchCurrentPlan();
  }, []);

  const handleManageSubscription = async () => {
    const adminAppUrl = window.location.origin;
    const response = await fetch('/api/stripe-portal-url', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ install_id: INSTALL_ID, return_url: adminAppUrl })
    });
    const data = await response.json();
    if (data.portalUrl) {
      window.open(data.portalUrl, '_blank');
    } else {
      alert(data.error || 'Failed to open Stripe portal.');
    }
  };

  // Get host param from URL
  const host = new URLSearchParams(window.location.search).get('host');
  const apiKey = 'df3e57d628e2bdee6edfba4ba75c944a'; // Your Shopify API key

  // Show a message if host param is missing
  if (!host) {
    return <div style={{ padding: 40, textAlign: 'center', color: 'red' }}>
      <h2>Missing host param</h2>
      <p>This app must be loaded from the Shopify admin. Please reload the app from your Shopify Apps list.</p>
    </div>;
  }

  const appBridgeConfig = {
    apiKey,
    host,
  };

  return (
    <AppBridgeProvider config={appBridgeConfig}>
      <AppProvider i18n={{}}>
        <Page title="Askeet">
          <Card sectioned>
            <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
              <div style={{ display: 'flex', gap: 10 }}>
                <Button onClick={() => setPage('home')} primary={page === 'home'}>Home</Button>
                <Button onClick={() => setPage('community')} primary={page === 'community'}>Community</Button>
              </div>
              {isPaid && (
                <Button onClick={handleManageSubscription}>
                  <span className="subscription-icon" role="img" aria-label="credit card">💳</span> Manage subscription
                </Button>
              )}
            </div>
            {page === 'community' ? (
              <CommunityPage />
            ) : (
              <TextContainer>
                <Chat currentPlan={currentPlan} />
              </TextContainer>
            )}
            <SubscriptionModal
              isOpen={showSubscriptionModal}
              onClose={() => setShowSubscriptionModal(false)}
              currentPlan={currentPlan}
              error={subscriptionError}
              onUpgradeSuccess={() => setShowSuccessModal(true)}
            />
            {showSubscriptionModal && <div className="modal-blocker" />}
            {showSuccessModal && (
              <div className="subscription-modal-overlay" style={{ zIndex: 2000 }}>
                <div className="success-modal" style={{
                  background: 'white',
                  borderRadius: 16,
                  maxWidth: 420,
                  minWidth: 320,
                  minHeight: 340,
                  padding: '48px 32px 40px 32px',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  textAlign: 'center',
                }}>
                  <button className="close-button" style={{ position: 'absolute', top: 18, right: 18 }} onClick={() => setShowSuccessModal(false)}>×</button>
                  <div style={{ fontSize: 64, marginBottom: 18 }}>🎉</div>
                  <h2 style={{ marginBottom: 16, color: '#005a9e', fontWeight: 700, fontSize: 28 }}>Congratulations!</h2>
                  <div style={{ fontSize: 20, marginBottom: 24, color: '#333' }}>
                    Your subscription has been <b>upgraded successfully</b> to <span style={{ color: '#0070f3' }}>Unlimited</span>!<br />Enjoy all premium features.
                  </div>
                  <Button primary size="large" onClick={() => setShowSuccessModal(false)}>
                    Close
                  </Button>
                </div>
              </div>
            )}
          </Card>
        </Page>
      </AppProvider>
    </AppBridgeProvider>
  );
}

export default App; 